if ("undefined" === typeof window) {
    importScripts("https://www.gstatic.com/firebasejs/9.9.1/firebase-app-compat.js");
    importScripts("https://www.gstatic.com/firebasejs/9.9.1/firebase-messaging-compat.js");

    var Audio;
    var useState;
    initializeFirebase();

    function initializeFirebase() {
        var firebaseConfig = {
            apiKey: "AIzaSyDxAylE8ymlCEMo1FqM3FQABqSilAA8Jv4",
            authDomain: "mobitrix-android.firebaseapp.com",
            databaseURL: "https://mobitrix-android.firebaseio.com",
            projectId: "mobitrix-android",
            storageBucket: "mobitrix-android.firebasestorage.app",
            messagingSenderId: "914093533371",
            appId: "1:914093533371:web:f2a1f1c6f080b7e21c619e",
            measurementId: "G-BE68PEMSLH",
            vapId: "BC9iXdc2B8R6GNGF3SOB8VpOzeAhXcsd-3iu4XOodmzTTW37VqAmOLOatzqT7J_I9-_tcNK2yzqHQMX0qw41Yws"
        };
        // Initialize Firebase
        if (firebase.messaging.isSupported()) {
            var firebaseApp = firebase.initializeApp(firebaseConfig);
            var messaging = firebase.messaging();
            messaging.onBackgroundMessage(function (payload) {

                //payload.notification.body="You Are Welcome"
                console.log("Received background Full Notification == ", payload);
                console.log("Received background Data== ", payload.data);
                console.log("Received background title== ", payload.notification.title);
                console.log("Received background Body== ", payload.notification.body);
                let messageBody = payload.data?.messageBody || 'New message received'; // Directly use messageBody

                console.log('Raw messageBody:', messageBody);

                // Extract the first part of messageBody before "==="
                const cleanMessageBody = messageBody.split("===")[0]?.trim();
                console.log("Clean MessageBody:", cleanMessageBody);

                // Convert message to user-friendly text
                const userFriendlyMessage = convertToUserFriendlyMessage(cleanMessageBody);

                console.log("Final Heading Message:", userFriendlyMessage);

                // Modify notification body
                const notificationTitle = payload.notification?.title || "New Notification";
                const notificationOptions = {
                    body: userFriendlyMessage,
                    icon: "/firebase-logo.png",
                };
                const channel = new BroadcastChannel("bg-notification");
                channel.postMessage({ payload: payload, url: "urls" });
                return self.registration.showNotification(notificationTitle,
                    notificationOptions);
            });
        } else {
            return;
        }
    }

    // Convert extracted messageBody to a user-friendly message
    function convertToUserFriendlyMessage(messageBody) {
        switch (messageBody.trim()) {
            case "New Delivery Request":
                return "New delivery available, please respond to confirm pickup.";
            default:
                return "You have a new notification.";
        }
    }
}